// Order types (replacing service types)
export const ORDER_TYPE_ONLINE = "ONLINE";
export const ORDER_TYPE_COUNTER = "COUNTER";

export const ORDER_TYPES = [
  ORDER_TYPE_ONLINE,
  ORDER_TYPE_COUNTER
];

// Legacy alias — CafeteriaForm still references service_type field
export const SERVICE_TYPES = ORDER_TYPES;

// Service options for counter orders
export const SERVICE_BREAKFAST_ON_DEMAND = "BREAKFAST_ON_DEMAND";
export const SERVICE_SNACK_BAR = "SNACK_BAR";
export const SERVICE_HOT_TABLE_ONE = "HOT_TABLE_ONE";
export const SERVICE_HOT_TABLE_TWO = "HOT_TABLE_TWO";
export const SERVICE_PANINI_ON_DEMAND = "PANINI_ON_DEMAND";
export const SERVICE_STIR_FRY = "STIR_FRY";
export const SERVICE_PASTA_BAR = "PASTA_BAR";
export const SERVICE_READY_TO_EAT_COLD = "READY_TO_EAT_COLD";
export const SERVICE_READY_TO_EAT_HOT = "READY_TO_EAT_HOT";
export const SERVICE_OTHER = "OTHER";

export const COUNTER_SERVICE_TYPES = [
  SERVICE_BREAKFAST_ON_DEMAND,
  SERVICE_SNACK_BAR,
  SERVICE_HOT_TABLE_ONE,
  SERVICE_HOT_TABLE_TWO,
  SERVICE_PANINI_ON_DEMAND,
  SERVICE_STIR_FRY,
  SERVICE_PASTA_BAR,
  SERVICE_READY_TO_EAT_COLD,
  SERVICE_READY_TO_EAT_HOT,
  SERVICE_OTHER
];

// Keep the operation types as they are
export const OPERATION_TYPE_PRODUCTION = "PRODUCTION";
export const OPERATION_TYPE_SATELLITE = "SATELLITE";
export const OPERATION_TYPE_AUTONOMOUS = "AUTONOMOUS";

export const OPERATION_TYPES = [
  OPERATION_TYPE_PRODUCTION,
  OPERATION_TYPE_SATELLITE,
  OPERATION_TYPE_AUTONOMOUS,
];
